import React from 'react';
import { Row, Table } from '@tanstack/react-table';
import TickCheckbox from '../Checkbox/TickCheckbox';
import * as FormUI from '../../pages/pageForm/FormUI';

interface TableCheckboxProps {
  checked: boolean;
  onClick: (e: MouseEvent) => void;
}

export const TableCheckbox = ({ checked, onClick }: TableCheckboxProps) => {
  const handleClick = (e: MouseEvent) => {
    onClick(e);
    e.stopPropagation(); // disable default sorting
  };

  return (
    <FormUI.CheckItemGroup>
      <TickCheckbox type="checkbox" checked={checked} onClick={handleClick} />
    </FormUI.CheckItemGroup>
  );
};

interface HeaderCheckboxProps<TData> {
  table: Table<TData>;
}

export const HeaderCheckbox = <TData,>({
  table,
}: HeaderCheckboxProps<TData>) => {
  return (
    <TableCheckbox
      checked={table.getIsAllRowsSelected()}
      onClick={(e) => table.getToggleAllRowsSelectedHandler()(e)}
    />
  );
};

interface RowCheckboxProps<TData> {
  row: Row<TData>;
  onClick?: () => void;
}

export const RowCheckbox = <TData,>({
  row,
  onClick,
}: RowCheckboxProps<TData>) => {
  const handleClick = (e: MouseEvent) => {
    if (onClick) {
      onClick();
    } else {
      row.toggleSelected();
    }
    e.stopPropagation();
  };

  return <TableCheckbox checked={row.getIsSelected()} onClick={handleClick} />;
};
